import { nanoid } from "nanoid";

function randomNumer(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function generateCircleProps(
  playSpaceElement,
  isBad = true,
  duration = 500,
  delay = 200
) {
  const offsetWidth = playSpaceElement.offsetWidth;
  const offsetHeight = playSpaceElement.offsetHeight;

  return {
    key: nanoid(),
    duration,
    delay,
    isBad,
    left: randomNumer(70, offsetWidth - 70) + "px",
    top: randomNumer(70, offsetHeight - 70) + "px",
  };
}

function generateCircles(circlesCount, playSpaceElement) {
  let duration = 500;
  let delay = 50;

  const goodCircle = generateCircleProps(
    playSpaceElement,
    false,
    duration,
    delay
  );

  const result = [goodCircle];

  for (let l = 1; l <= circlesCount; l++) {
    const circle = generateCircleProps(playSpaceElement, true, duration, delay);
    result.push(circle);

    // duration += 100;
    delay += 50;
  }

  return result;
}

export { generateCircles };
